import React, { forwardRef, useEffect, useRef, useState } from 'react'
import PathSearch from '../common/sidebars/right/PathSearch'
import { Portal } from 'components/utility/portal'
import clsx from 'clsx'

export const TAB_NAVIGATOR = Object.freeze({
  SEARCH: 'search',
  ASSIGN: 'assign',
})

const AddNewpath = ({ onCancel, onSubmit }) => {
  const [activeTab, setActiveTab] = useState(TAB_NAVIGATOR.SEARCH)
  const [pathSelected, setPathSelected] = useState()

  const handleSelectPathItem = (path) => {
    setPathSelected(path)
    setActiveTab(TAB_NAVIGATOR.ASSIGN)
  }

  const handleSubmit = () => {
    onSubmit(pathSelected)
    setActiveTab(TAB_NAVIGATOR.SEARCH)
  }

  return (
    <div className="dome-full-width dome-d-flex dome-align-start dome-flex-column dome-gap24">
      <div className="dome-d-flex dome-align-start dome-flex-column dome-gap12">
        <span className="dome-h2 dome-color-dark-grey">add new path</span>
        <span className="dome-p1 dome-color-darkest-grey">Search for a new path to add to this section.</span>
        <div className="dome-d-flex dome-gap3 dome-align-center">
          <span>
            <i className="fa-light fa-circle-exclamation dome-color-med-grey"></i>
          </span>
          <span className="dome-p3 dome-color-med-grey">Paths already used on this form cannot be added.</span>
        </div>
      </div>
      {activeTab === TAB_NAVIGATOR.SEARCH && (
        <div className="dome-full-width">
          <PathSearch disableCopy={true} onSelectPathItem={handleSelectPathItem} />
        </div>
      )}
      {activeTab === TAB_NAVIGATOR.ASSIGN && (
        <div
          style={{
            width: '100%',
            padding: 12,
            borderRadius: 6,
            background: '#F9F9F9',
            border: '1px solid var(--accent, #F0F0F0)',
          }}
        >
          <div className="dome-d-flex dome-flex-column">
            <span className="dome-p1 dome-color-darkest-grey">{pathSelected?.field?.label}</span>
            <span className="dome-p3 dome-color-med-grey">{pathSelected?.path}</span>
            <span className="dome-p3 dome-color-med-grey">{pathSelected?.field?.type}</span>
            <span className="dome-p3 dome-color-med-grey">source: {pathSelected?.source}</span>
          </div>
        </div>
      )}
      <div className="dome-full-width dome-d-flex dome-justify-between">
        <button
          type="button"
          onClick={() => {
            activeTab === TAB_NAVIGATOR.SEARCH ? onCancel() : setActiveTab(TAB_NAVIGATOR.SEARCH)
          }}
          className={clsx(
            'dome-btn dome-btn-link dome-btn-link-med-grey',
            activeTab === TAB_NAVIGATOR.SEARCH ? 'dome-btn-link-cancel' : 'dome-btn-link-chevron-left'
          )}
        >
          {activeTab === TAB_NAVIGATOR.SEARCH ? 'cancel' : 'back'}
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={!pathSelected}
          className={clsx('dome-btn dome-btn-base', !pathSelected ? 'dome-btn-disabled' : 'dome-btn-green-stroke')}
        >
          add
        </button>
      </div>
    </div>
  )
}

const AddNewPathModal = forwardRef(({ open = false, onClose = () => {}, onSubmit = () => {}, ...props }, ref) => {
  const [show, setShow] = useState(open)
  const overlayRef = useRef(null)

  useEffect(() => {
    setShow(open)
  }, [open])

  const handleClose = () => {
    setShow(false)
    onClose()
  }

  const handleClickOutsideModal = (e) => {
    if (e.target !== overlayRef.current) return
    handleClose()
  }

  useEffect(() => {
    if (show) {
      document.body.classList.add('interstitial-activated')
    } else {
      document.body.classList.remove('interstitial-activated')
    }
    return () => document.body.classList.remove('interstitial-activated')
  }, [show])

  return (
    <Portal>
      <div ref={ref} className={clsx('add-new-path-modal-overlay dome-full-width dome-full-height', show && 'show')}>
        <div
          ref={overlayRef}
          onClick={handleClickOutsideModal}
          className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center"
        >
          <div className="add-new-path-modal-container">
            <AddNewpath
              {...props}
              onSubmit={(value) => {
                handleClose()
                onSubmit(value)
              }}
              onCancel={handleClose}
            />
          </div>
        </div>
      </div>
    </Portal>
  )
})

AddNewPathModal.displayName = 'AddNewPathModal'

export default AddNewPathModal
